import { ConfirmModalParams } from 'core/models';

class RemoveFiltersModalUtility {
	constructor(props) {
		const { viewStore } = props;
		this.viewStore = viewStore;
	}

	removeFiltersConfirm = new ConfirmModalParams({
		onConfirm: async () => {
			this.promise(true);
			this.removeFiltersConfirm.close();
		},
		onCancel: async () => {
			this.promise(false);
			this.removeFiltersConfirm.close();
		},
	});

	async openModalOnStateChange() {
		this.removeFiltersConfirm.open({
			message: 'REMOVEFILTERSCONFIRM',
		});
		return new Promise(resolve => {
			this.promise = resolve;
		});
	}

	async handleRemoveFiltersButtonClick() {
		const changeState = await this.openModalOnStateChange();
		if (changeState) {
			this.viewStore.tableFilter.removeAll();
		}

		return Promise.reject();
	}
}

export default RemoveFiltersModalUtility;
